import { Box, HStack, Spinner, Text, VStack, Skeleton } from "@chakra-ui/react";
import { PreviewCard } from "../EventDetail/Nav/Settings/PreviewCard";

interface PreviewData {
  faceValue: number;
  fees: number;
  rebate: number;
  finalPrice: number;
  isLoading?: boolean;
}

interface PreviewCardsSectionProps {
  previews: PreviewData[];
  title?: string;
  isCalculating?: boolean;
  percentage?: number;
  previewCardsBgColor?: string;
}

export const PreviewCardsSection = ({
  previews,
  percentage = 0,
  title = "Fan Price Preview",
  isCalculating = false,
  previewCardsBgColor = "#f5f5f5",
}: PreviewCardsSectionProps) => {
  return (
    <Box bg={previewCardsBgColor} p={4} borderRadius="2xl">
      <VStack spacing={4} align="stretch">
        <HStack w="full" justify="space-between">
          <HStack justify="space-between">
            <Text fontWeight="medium">{title}</Text>
            {isCalculating && <Spinner size="sm" />}
          </HStack>
          <Text
            fontSize="lg"
            fontWeight="medium"
            textAlign="center"
            color={isCalculating ? "gray.400" : "gray.900"}
          >
            {percentage.toFixed(2)}%
          </Text>
        </HStack>
        <HStack spacing={4} align="stretch">
          {isCalculating && previews.length === 0
            ? // Show skeleton cards when loading and no data yet
              [1, 2, 3].map((index) => (
                <Box key={index} flex={1} bg="white" borderRadius="lg">
                  <VStack align="flex-start" spacing={1}>
                    <HStack
                      spacing={2}
                      w="full"
                      borderBottom="1px solid"
                      borderColor="gray.200"
                      py={2}
                      px={4}
                    >
                      <Skeleton height="24px" flex={1} />
                      <Spinner size="sm" />
                    </HStack>
                    <VStack
                      align="flex-start"
                      spacing={0}
                      fontSize="sm"
                      px={4}
                      py={2}
                      w="full"
                    >
                      <HStack
                        spacing={1}
                        justifyContent="space-between"
                        w="full"
                        mb={1}
                      >
                        <HStack spacing={1}>
                          <Skeleton height="14px" width="25px" />
                          <Skeleton height="14px" width="45px" />
                        </HStack>
                        <Skeleton
                          height="12px"
                          width="12px"
                          borderRadius="full"
                        />
                      </HStack>
                      <HStack spacing={1} mb={1}>
                        <Skeleton height="14px" width="35px" />
                        <Skeleton height="14px" width="50px" />
                      </HStack>
                      <HStack spacing={1}>
                        <Skeleton height="14px" width="45px" />
                        <Skeleton height="14px" width="50px" />
                      </HStack>
                    </VStack>
                  </VStack>
                </Box>
              ))
            : // Show actual preview cards
              previews.map((preview, index) => (
                <PreviewCard key={index} preview={preview} />
              ))}
        </HStack>
      </VStack>
    </Box>
  );
};
